import * as React from 'react';

interface Props {
  eventName: string;
  date: string;
  schoolName: string;
  venue: string;
  status: string;
  folder: string;
  onClose: () => void;
  actions?: React.ReactNode;
}

const DetailField = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div className="schoolInvitesDetails__field">
    <span>{label}</span>
    <strong>{value || '-'}</strong>
  </div>
);

export const InviteDetailsDrawer = ({
  eventName,
  date,
  schoolName,
  venue,
  status,
  folder,
  onClose,
  actions
}: Props) => {
  const initials = (eventName || 'Fixture invite')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word.charAt(0).toUpperCase())
    .join('');

  return (
    <>
      <div className="schoolInvitesDetails__scrim" onClick={onClose} />
      <aside className="schoolInvitesDetails" role="dialog" aria-modal="true" aria-label="Invitation details">
        <div className="schoolInvitesDetails__head">
          <div className="schoolInvitesDetails__identity">
            <span className="schoolInvitesDetails__avatar">{initials}</span>
            <div>
              <h2>{eventName || 'Fixture invite'}</h2>
              <p>{folder} · {date || 'Date not specified'}</p>
            </div>
          </div>
          <button type="button" className="schoolInvitesDetails__close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="schoolInvitesDetails__body">
          <section className="schoolInvitesDetails__section">
            <div className="schoolInvitesDetails__sectionTitle">Invitation</div>
            <span className="schoolInvitesDetails__status">{status || 'Pending'}</span>
          </section>
          <section className="schoolInvitesDetails__section">
            <div className="schoolInvitesDetails__sectionTitle">Event details</div>
            <DetailField label="Event" value={eventName} />
            <DetailField label="Date" value={date} />
            <DetailField label="Venue" value={venue} />
          </section>
          <section className="schoolInvitesDetails__section">
            <div className="schoolInvitesDetails__sectionTitle">School</div>
            <DetailField label="School name" value={schoolName} />
          </section>
        </div>
        {actions ? <div className="schoolInvitesDetails__actions">{actions}</div> : null}
      </aside>
    </>
  );
};
